// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var QueryParams = require("../../reason/QueryParams.bs.js");

var config = Object.fromEntries([
      [
        "after",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "before",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ],
      [
        "search",
        QueryParams.UseQueryParams.ParamConfigs.stringParam
      ]
    ]);

var Config = {
  config: config
};

var include = QueryParams.UseQueryParams.Make(Config);

var use = include.use;

var encode = include.encode;

exports.Config = Config;
exports.use = use;
exports.encode = encode;
/* config Not a pure module */
